import {Component} from '@angular/core';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-facebook-browser-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIcon,
    MatButton,
  ],
  template: `
    <h2 mat-dialog-title class="flex items-center gap-2">
      <mat-icon color="warn">info</mat-icon>
      Open Playble in your browser
    </h2>
    <mat-dialog-content class="space-y-3">
      <p>
        Facebook's in-app browser blocks access to the device Geolocation API, so we can't automatically detect your
        location here.
      </p>
      <p class="text-sm text-slate-600 dark:text-slate-300">
        To use location-based features, open this page in Safari, Chrome, or your device's default browser. You can continue
        without sharing your location, but events will be shown from the default area.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="gap-2">
      <button mat-stroked-button mat-dialog-close color="primary">Got it</button>
    </mat-dialog-actions>
  `
})
export class FacebookBrowserDialog {
}
